export enum QualificationRenewalModeEnum {
  RENEWAL = "RENEWAL",
  RECYCLING = "RECYCLING"
}
